import React, { createContext, useContext, useState, useEffect } from 'react';
import { ROUTES } from '../config/routes';
import { useLocation } from 'react-router-dom';

// Create Navigation Context
const NavigationContext = createContext();

// Custom hook for using navigation context
export const useNavigation = () => {
  return useContext(NavigationContext);
};

// Navigation Provider component
export const NavigationProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState(ROUTES.FEED.name); // Default to feed
  const location = useLocation();

  // Sync active tab with current URL
  useEffect(() => {
    // Find the route that matches the current pathname
    const currentRoute = Object.values(ROUTES).find(route => 
      location.pathname === route.path || 
      (route.name === 'feed' && location.pathname === '/posts')
    );
    
    if (currentRoute) {
      setActiveTab(currentRoute.name);
    }
  }, [location.pathname]);

  const navigateTo = (routeName) => {
    const route = Object.values(ROUTES).find(r => r.name === routeName);
    if (route) {
      setActiveTab(route.name);
      return route.path;
    }
    return ROUTES.FEED.path; // Fallback to feed
  };

  const getActiveRoute = () => {
    return Object.values(ROUTES).find(route => route.name === activeTab) || ROUTES.FEED;
  };

  const isTabActive = (routeName) => {
    return activeTab === routeName;
  };

  return (
    <NavigationContext.Provider value={{
      activeTab,
      setActiveTab,
      navigateTo,
      getActiveRoute,
      isTabActive,
      routes: ROUTES
    }}>
      {children}
    </NavigationContext.Provider>
  );
};
